import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';

var _excluded = ["as", "children"];
var List = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: as,
    m: "0",
    p: "0",
    listStyle: "none"
  }, rest, {
    ref: ref
  }), children);
});
List.displayName = 'List';
List.defaultProps = {
  as: 'ul'
};

export { List };
//# sourceMappingURL=List.js.map
